import { createFileRoute, redirect } from "@tanstack/react-router";
import { identityQueryOptions } from "@/api/me";
import { clearReauthSentinel } from "@/api/reauth";
import { WorkspaceSelectorPage } from "@/components/selector/workspace-selector-page";
import { WorkspaceProvider } from "@/contexts/workspace-context";

// Boot route. Fetches identity and decides:
//   - exactly one accessible workspace in exactly one accessible
//     organization → silent redirect to /w/$id; the user has nothing to
//     choose.
//   - anything else (multi-ws, multi-org, zero-ws-with-createable-orgs,
//     fully-empty) → render WorkspaceSelectorPage.
export const Route = createFileRoute("/")({
    beforeLoad: async ({ context }) => {
        const identity = await context.queryClient.ensureQueryData(identityQueryOptions);
        clearReauthSentinel();

        if (identity.workspaces.length === 1 && identity.organizations.length === 1) {
            const target = identity.workspaces[0];
            if (target) {
                throw redirect({ to: "/w/$workspaceId", params: { workspaceId: target.id } });
            }
        }
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <WorkspaceProvider>
            <WorkspaceSelectorPage />
        </WorkspaceProvider>
    );
}
